import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import useFetchMenu from 'Common/FetchAllMenu'
import { SidebarSkeleton } from './SidebarSkeleton '

const HRTabSidebar = ({ iconColor }) => {
    const { menu: human_resource, loading: tuningLoading } = useFetchMenu("human_resource");

    if (tuningLoading) {
        return <SidebarSkeleton iconColor={iconColor} />
    }
    const DefaultIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
            <path d="M8 11a5 5 0 1 0 3.998 1.997" />
            <path d="M12.002 19.003a5 5 0 1 0 3.998 -8.003" />
        </svg>

    );
    return (
        <>
            <h6 className="fl-title title-font ps-2 small text-uppercase text-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Usual</h6>
            <ul className={`list-unstyled mb-4 menu-list ${iconColor}`}>
                <li>
                    <NavLink to="/admin/index-hr" aria-label="HRMS Dashboard">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
                            <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                            <path d="M10 12h4v4h-4z"></path>
                        </svg>
                        <span className="mx-3">HR Dashboard</span>
                    </NavLink>
                </li>
                {human_resource?.map((parent) => {
                    const collapseId = `menu-${parent.menu_id}`;

                    return (
                        <li key={parent.menu_id}>
                            {/* Parent menu (collapse toggle) */}
                            <Link
                                to={`#${collapseId}`}
                                data-bs-toggle="collapse"
                                aria-expanded="false"
                                className="dropdown-toggle d-flex align-items-center"
                                aria-label={parent.menu_title}
                            >
                                {/* Optional icon */}
                                {parent.icon ? (
                                    <span
                                        className="svg-stroke"
                                        dangerouslySetInnerHTML={{ __html: parent.icon }}
                                    />
                                ) : (
                                    <DefaultIcon />
                                )}

                                <span className="mx-3 text-capitalize text-wrap ">
                                    {parent.menu_title}
                                </span>
                            </Link>

                            {/* Child menu */}
                            {parent.children && parent.children.length > 0 && (
                                <ul
                                    className="collapse list-unstyled"
                                    id={collapseId}
                                >
                                    {parent.children.map((child) => (
                                        <li key={child.menu_id}>
                                            <NavLink
                                                to={`/admin/${child.page_url}`}
                                                className="text-capitalize"
                                                aria-label={child.menu_title}
                                            >
                                                {child.menu_title}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    );
                })}
            </ul>
        </>
    )
}

export default HRTabSidebar